<template>
<nav id="tag-nav">
  <ul class="nav nav-pills">
    <li>
      <router-link
        :to="{ name: 'create_tag' }"
      >
        Create Tag
      </router-link>
    </li>
    <li v-if="tagId">
      <router-link
        :to="{ name: 'edit_tag', params: { tagId: tagId }}"
      >
        Edit Tag
      </router-link>
    </li>
    <li v-if="tagId">
      <router-link
        :to="{ name: 'tag_purchases', params: { tagId: tagId }}"
      >
        Tag Purchases
      </router-link>
    </li>
  </ul>
</nav>
</template>

<script>
export default {
  created () {
    this.tagId = this.$parent.tagId
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TagNav.vue